const VariableType = {
	ComponentMassFrac: 'ComponentMassFrac',
	Variable: 'Variable'
};

export default VariableType;
